import Home from "./Home";

function HomePage(){
    return(
        <div>
            <Home/>
        </div>
    )
}
export default HomePage;